export const colorMappingDataSet = {
    shore: {
        'ship operator': '#05BC52',
        'crew manning': '#ff9900',
        'port authority': '#00D1FF',
        'ship agent': '#00FFB2',
        'classification society': '#B530E3',
        'ship chandler': '#6aa84f',
        'technical services': '#ea4335',
        'shipyard': '#8e7cc3',
        'training institute': '#e69138',
        'service provider': '#666666',
        'maritime key contacts': '#FFC800',
        'seafarer helplines': '#de02de',
        'head office': '#3d85c6',
        'medical services': '#64e000',
    },
    ship: {
        'deck': '#376AFA',
        'engine': '#572DFF',
        'saloon': '#a64d79',
        'fleet vessels': '#38761d',
    },
    generic: '#727484'
};

export const getColorForRankAndRoles = (contactData) => {
    let rankLevel1 = contactData?.rankLevel1?.toLowerCase();
    let rankLevel2 = contactData?.rankLevel2?.toLowerCase();

    if (!rankLevel1) return colorMappingDataSet?.generic;
    let color = colorMappingDataSet?.generic;

    if (rankLevel1 && rankLevel2) {
        color = colorMappingDataSet?.[rankLevel1]?.[rankLevel2] || color;
    }
    return color;
}
